<template>
  <Toast />
  <Dialog v-model:visible="showErrorDialog" modal :header="'Terjadi Kesalahan'" :closable="true"
    class="w-[90vw] md:w-[50vw]">
    <div class="flex items-start space-x-3">
      <ExclamationCircleIcon class="h-6 w-6 text-red-500" />
      <p class="text-gray-700 dark:text-gray-200">{{ errorMessage }}</p>
    </div>
    <template #footer>
      <Button label="Tutup" @click="showErrorDialog = false" severity="secondary" />
    </template>
  </Dialog>
  <IndexView />
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/role" />
      <PageTitle :title="isEdit ? 'Edit Role' : 'Tambah Role'" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div class="grid grid-cols-12 gap-4 mb-6">
          <div class="col-span-6">
            <InputTextCustom v-model="role.name" id="name-role" label="Nama" placeholder="Masukkan nama"
              input_class="w-full" :valid="validation.name.valid" :error-message="validation.name.message" :disabled="true" />
          </div>
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>Feature</TableHeadCell>
                    <TableHeadCell>Menu</TableHeadCell>
                    <TableHeadCell>View</TableHeadCell>
                    <TableHeadCell>View Self</TableHeadCell>
                    <TableHeadCell>Create</TableHeadCell>
                    <TableHeadCell>Update</TableHeadCell>
                    <TableHeadCell>Delete</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-for="(permission, index) in allPermissions" :key="permission.id" :index="index">
                    <TableCell>{{ permission.name }}</TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_menu"
                        @click="toggleRolePermission(permission.id, 'act_menu')"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_view"
                        @click="toggleRolePermission(permission.id, 'act_view')"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_view_self"
                        @click="toggleRolePermission(permission.id, 'act_view_self')"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_create"
                        @click="toggleRolePermission(permission.id, 'act_create')"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_update"
                        @click="toggleRolePermission(permission.id, 'act_update')"
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        type="checkbox"
                        :checked="allRolePermissions.find(rp => rp.permission_id == permission.id)?.act_delete"
                        @click="toggleRolePermission(permission.id, 'act_delete')"
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import { mapGetters, mapActions } from 'vuex';
import ViewContainer from "@/components/ViewContainer.vue";
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import { Button, Dialog, Toast } from 'primevue';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";

export default {
  name: "AddEditUser",
  props: ['id'],
  components: {
    IndexView,
    PageTitle,
    BackButton,
    ViewContainer,
    InputTextCustom,
    Toast,
    Dialog,
    Button,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
  },
  data() {
    return {
      role: {
        id: null,
        name: '',
      },
      isEdit: false,
      originalPassword: '',
      validation: {
        name: {
          valid: true,
          message: ''
        },
      },
      field: ['name'],
      showErrorDialog: false,
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters('roles', ['allRoles']),
    ...mapGetters('permissions', ['allPermissions']),
    ...mapGetters('role_permissions', ['allRolePermissions']),
  },
  methods: {
    ...mapActions('roles', ['createRole', 'updateRole', 'fetchRoleById']),
    async submitRole() {
      if (this.user.password !== this.user.confirmation) {
        this.showErrorDialog = true;
        this.errorMessage = 'Konfirmasi password tidak sesuai!';
        this.validation.confirmation.valid = false;
        this.validation.confirmation.message = 'Konfirmasi password tidak sesuai!';
        return;
      }

      try {
        const userData = {
          id: this.id,
          name: this.user.name,
          role_id: this.user.role_id,
          phone: this.user.phone,
          address: this.user.address,
        }
        if (this.user.password && this.user.confirmation) {
          const token = localStorage.getItem('auth_token');
          userData.password = this.user.password;
          userData.confirmation = this.user.confirmation;
          userData.token = token;
        }

        if (this.isEdit) {
          await this.updateUser(userData);
        } else {
          userData.password = this.user.password;
          userData.email = this.user.email;
          await this.createUser(userData);
        }
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Data user berhasil disimpan!', life: 5000 });
        this.$router.push('/user');
      }
      catch (error) {
        console.error('Failed to update user', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },

    async toggleRolePermission(permissionId, key) {
      let rolePermission = this.allRolePermissions.find(rp => rp.permission_id == permissionId);
      if (!rolePermission) {
        let payload = {
          permission_id: permissionId,
          act_create: false,
          act_delete: false,
          act_delete_self: false,
          act_menu: false,
          act_update: false,
          act_update_self: false,
          act_view: false,
          act_view_self: false,
          role_id: this.role.id
        };
        payload[key] = true;
        
        await this.$store.dispatch('role_permissions/createRolePermission', payload);
      } else {
        const payload = { id: rolePermission.id };
        payload[key] = !rolePermission[key];

        await this.$store.dispatch('role_permissions/updateRolePermission', payload);
      }
      this.$store.dispatch('role_permissions/fetchRolePermissions', { limit: 1000, role_id: this.id });
    },
  },
  async created() {
    this.$store.dispatch('permissions/fetchPermissions', { limit: 1000 });
    this.$store.dispatch('role_permissions/fetchRolePermissions', { limit: 1000, role_id: this.id });

    const roleId = this.id;
    if (roleId) {
      this.isEdit = true;

      try {
        const response = await this.fetchRoleById(roleId);
        const roleData = response.data;

        this.role = {
          id: roleData.id,
          name: roleData.name,
        };
        this.originalPassword = roleData.password;
      }
      catch (error) {
        console.error('Failed to fetch role', error);
      }
    }
  }
}
</script>